import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { valToPercent } from '../../../../../../helpers/value'

export const CustomCell = ({
  rowSpan,
  rowId,
  rowIndex,
  colId,
  selectCellData,
  format,
  colCustomId,
}) => {
  const val = useSelector(selectCellData(rowId, rowIndex, colId))
  const valChange = useSelector(selectCellData(rowId, rowIndex, colCustomId))
  const valRiskLevel = useSelector(selectCellData(rowId, rowIndex, 'riskLevel'))
  const valRiskLevelCompare = useSelector(
    selectCellData(rowId, rowIndex, 'riskLevelCompare'),
  )
  const locale = useSelector((state) => state.i18n.locale)

  const renderBoxRiskLevel = (val) => {
    return (
      <td rowSpan={rowSpan} style={{ textAlign: 'right' }}>
        <div
          className="dFlex justifyContentEnd"
          style={{
            background: val?.colorCode,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 600,
            padding: 2,
            marginLeft: 'auto',
            maxWidth: 150,
            textAlign: 'center',
          }}
        >
          {val?.riskGradeTypeName}
        </div>
      </td>
    )
  }

  if (colId === 'defaultIndustry' && valRiskLevel) {
    return renderBoxRiskLevel(valRiskLevel)
  }

  if (colId === 'compareIndustry' && valRiskLevelCompare) {
    return renderBoxRiskLevel(valRiskLevelCompare)
  }

  if (colCustomId) {
    const getColor = () => {
      return valChange > 0 ? '#3DA967' : valChange < 0 ? '#E0505B' : '#191D25'
    }
    return (
      <td
        rowSpan={rowSpan}
        style={{
          textAlign: ['ratioName', 'group'].includes(colId) ? 'left' : 'right',
        }}
      >
        <Element className="fw600">
          {Number.isInteger(val) ? val : format(val)}
        </Element>
        <Element
          style={{
            fontSize: 10,
            color: getColor(),
          }}
        >
          {valChange ? (
            <Icon
              className={`${
                valChange > 0 ? 'icon-caret-top' : 'icon-caret-bottom'
              } pl1`}
              style={{ color: getColor(), fontSize: 8 }}
            />
          ) : null}{' '}
          {valToPercent(Math.abs(valChange), locale, true)}
        </Element>
      </td>
    )
  }

  return (
    <td
      rowSpan={rowSpan}
      style={{
        textAlign: ['ratioName', 'group'].includes(colId) ? 'left' : 'right',
      }}
    >
      {format(val)}
    </td>
  )
}

CustomCell.propTypes = {
  colId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowSpan: PropTypes.number,
  selectCellData: PropTypes.func,
  format: PropTypes.func,
}

CustomCell.defaultProps = {
  rowSpan: 1,
  selectCellData: () => {},
  format: () => {},
}
